// Generated by CoffeeScript 2.7.0
var GroupOptions, group_comp;

group_comp = {
  name: 'group',
  template: `<div class='list-group'>
  <div class='list-group-name' v-if='group.name'>{{ group.name }}</div>
  <div class='list'>
    <div class='list-item'
         v-for='option in group.options'
         :class="{'active': option._selected}"
         :key='option.id'
         @click.stop='toggle(option)'>
      <slot name='option-item' :option='option'>
      </slot>
    </div>
  </div>
</div>`,
  props: ['group', 'multiple'],
  created: function() {
    var base;
    return (base = this.group).allow_clear != null ? base.allow_clear : base.allow_clear = true;
  },
  methods: {
    unselect: function(option) {
      if (option._selected) {
        return this.toggle(option);
      }
    },
    toggle: function(option) {
      var last_selected_option;
      if (option._selected) {
        if (this.group.allow_clear || this.multiple) {
          option._selected = false;
        }
      } else {
        if (!this.multiple) {
          last_selected_option = _.find(this.group.options, function(option) {
            return option._selected;
          });
          if (last_selected_option) {
            last_selected_option._selected = false;
          }
        }
        option._selected = true;
      }
      return this.$emit('valueChanged', option);
    }
  }
};

export default GroupOptions = Vue.extend({
  components: {
    group: group_comp
  },
  template: `<div class='group-options'>
  <group
    v-for='(group, index) in filteredGroupedOptions'
    :key='index'
    :group='group'
    :multiple='multiple'
    ref='children'
    @valueChanged='valueChangedFunc'>
    <template slot='option-item' slot-scope='{ option }'>
      <slot name='option-item-template' :option='option'>
        <div class='tip icon'>
          <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
        </div>
        <div class='content'>{{ option.name }}</div>
      </slot>
    </template>
  </group>

  <slot name='options-blankslate' v-if='_.isEmpty(groupedOptions)'>
    <div class='list-group'>
      <div class='list-group-name'>没有你想要的</div>
    </div>
  </slot>
  <slot name='filter-blankslate' v-else-if='_.isEmpty(filteredGroupedOptions)'>
    <div class='list-group'>
      <div class='list-group-name'>没有你想要的</div>
    </div>
  </slot>
</div>`,
  props: {
    groupedOptions: {
      type: [Array],
      required: true
    },
    keyword: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    filteredGroupedOptions: function() {
      var kw;
      kw = this.keyword;
      if (_.isEmpty(kw)) {
        return this.groupedOptions;
      } else {
        return _.reduce(this.groupedOptions, function(memo, group) {
          var options;
          options = _.filter(group.options, function(option) {
            return option.name.indexOf(kw) > -1;
          });
          if (options.length) {
            memo.push({
              name: group.name,
              allow_clear: group.allow_clear,
              options: options
            });
          }
          return memo;
        }, []);
      }
    }
  },
  methods: {
    getSelectedOptions: function() {
      return _.chain(this.groupedOptions).map(function(group) {
        return _.select(group.options, function(option) {
          return option._selected;
        });
      }).flatten().value();
    },
    valueChangedFunc: function(option) {
      var selected_options;
      if (!this.multiple && option._selected) {
        selected_options = this.getSelectedOptions();
        if (_.isEmpty(selected_options)) {
          return;
        }
        _.each(selected_options, function(_option) {
          if (_option === option) {
            return;
          }
          return _option._selected = false;
        });
      }
      return this.$emit('valueChanged', this, option);
    },
    unselect: function(option) {
      if (!option._selected) {
        return;
      }
      option._selected = false;
      return this.$emit('valueChanged', this, option);
    }
  }
});
